import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {ReactComponent as UserIcon} from "ui-components-rollup/src/images/monochrome-icons/ic-user.svg";
import styles from "./../MainHeader.module.scss";
import userMenuStyles from "./UserMenu.module.scss";
import SlidingWidget from "./SlidingWidget"
import {Checkbox} from "ui-components-rollup/dist/Forms";
import {Link} from "react-router-dom";
import buttons from "ui-components-rollup/src/components/buttons.module.scss";

const StaticDetails = ({children, label, value}) => {
    return <div className={userMenuStyles['static-details']}>
        {children}
        <div className={userMenuStyles['details-value']}>{value}</div>
        <div className={userMenuStyles['details-label']}>{label}</div>
    </div>
};

const CheckboxDetails = ({label, value, isChecked, onChange}) => {
    return <div className={userMenuStyles['static-details']}>
        <div className={userMenuStyles['details-value']}>
            <Checkbox checked={isChecked} onChange={onChange}>{value}</Checkbox>
        </div>
        <div className={userMenuStyles['details-label']}>{label}</div>
    </div>
};

export default () => {
    const dispatch = useDispatch();
    const {name, email, company, isNetAppInternal} = useSelector(state => state.auth);
    const isUserNotificationOptedIn = useSelector(state => state.tenancy.isUserNotificationOptedIn);
    const permissions = useSelector(state => state.tenancy.permissions);
    const isDark = process.env.REACT_APP_IS_DARK === 'true';

    return <SlidingWidget
        widgetKey="user"
        menuTitle="User Settings"
        MenuIcon={UserIcon}
        MenuActionButton={() => {
            return <button className={styles['logout-button']} onClick={() => dispatch({
                type: "AUTH:LOGOUT"
            })}>Logout</button>
        }}
        triggerClassName={styles['widget-button']}
        triggerActiveClassName={[styles['widget-button-active']]}
        triggerChildren={<UserIcon/>}
    >
        <div>
            <StaticDetails label="Name" value={name}/>
            <StaticDetails label="Email" value={email}/>
            <StaticDetails label="Company" value={company}>
                {isNetAppInternal && <Link to="/netapp-internal" className={buttons.text} style={{position: "absolute", right: 40, marginTop: 15, zIndex: 1}} onClick={() => {
                    dispatch({
                        type: "MENU:CLOSE-WIDGET"
                    })
                }}>NetApp Internal</Link>}
            </StaticDetails>
            {permissions.cloudManagerNotificationsReport && !isDark && <CheckboxDetails label="Notification" value="Email me Cloud Volumes ONTAP report" isChecked={isUserNotificationOptedIn} onChange={(e) => {
                dispatch({
                    type: "TENANCY:USER-NOTIFICATION-OPT-IN",
                    payload: {
                        value: e.target.checked
                    }
                })
            }}/>}
        </div>
    </SlidingWidget>
};
